import script from "./content.vue?vue&type=script&setup=true&lang=js"
export * from "./content.vue?vue&type=script&setup=true&lang=js"

import "./content.vue?vue&type=style&index=0&id=33ac3ae6&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33ac3ae6"]])

export default __exports__